import Flickity from 'flickity';
import Alpine from 'alpinejs';

document.addEventListener("alpine:init", () => {

	Alpine.data('slider', () => {
		const elem = '.x-slider';
		let slider = null;
		let palette =  Alpine.reactive({ color: 'blue' });
		const options = {
			pageDots: true,
			wrapAround: true,
			prevNextButtons: false,
			groupCells: false,
			contain: false,
			cellAlign: 'left'
		};
		return {
			init(){
				
				slider = new Flickity( this.$el.querySelector( elem ), options);
				const cells = slider.cells;
				palette.color = cells[0].element.dataset?.palette;
				slider.on('select', function(index) {
					palette.color = cells[index].element.dataset?.palette;
				});
			},
			get paletteClass(){
				return `theme-${ palette.color }`;
			},
			nextSlide(){
				slider.next();
			},
			prevSlide(){
				slider.previous();
			}
		}
	});

});